import React from "react";

const Loader = ({ message = "Please wait..." }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-base-100 p-6 rounded-lg flex flex-col items-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-base-content font-medium">{message}</p>
      </div>
    </div>
  );
};

export default Loader;
